/**
 * 业绩统计 - 数据管理 Hook
 */

import { useState, useEffect, useCallback } from 'react';
import { message } from 'antd';
import {
    performancePeriodService,
    performanceSummaryService,
    PerformancePeriod,
    PerformanceStatistics,
    DepartmentPerformanceDetail,
} from '../../../../services/administrationService';

export const usePerformanceStatistics = () => {
    const [loading, setLoading] = useState(false);
    const [periods, setPeriods] = useState<PerformancePeriod[]>([]);
    const [selectedPeriodId, setSelectedPeriodId] = useState<number | undefined>();
    const [statistics, setStatistics] = useState<PerformanceStatistics | null>(null);

    // 弹窗状态
    const [detailModalVisible, setDetailModalVisible] = useState(false);
    const [detailLoading, setDetailLoading] = useState(false);
    const [selectedDeptDetail, setSelectedDeptDetail] = useState<DepartmentPerformanceDetail | null>(null);
    const [entryModalVisible, setEntryModalVisible] = useState(false);

    const loadPeriods = useCallback(async () => {
        try {
            const data = await performancePeriodService.list({ status: 'active' });
            setPeriods(data);
            if (data.length > 0 && !selectedPeriodId) {
                setSelectedPeriodId(data[0].id);
            }
        } catch (error) {
            console.error('Failed to load periods:', error);
            message.error('加载考核周期失败');
        }
    }, [selectedPeriodId]);

    const loadStatistics = useCallback(async () => {
        if (!selectedPeriodId) return;
        setLoading(true);
        try {
            const data = await performanceSummaryService.getStatistics(selectedPeriodId);
            setStatistics(data);
        } catch (error) {
            console.error('Failed to load statistics:', error);
            message.error('加载业绩统计失败');
        } finally {
            setLoading(false);
        }
    }, [selectedPeriodId]);

    const viewDepartmentDetail = async (departmentId: number) => {
        if (!selectedPeriodId) return;
        setDetailLoading(true);
        setDetailModalVisible(true);
        try {
            const data = await performanceSummaryService.getDepartmentDetail(selectedPeriodId, departmentId);
            setSelectedDeptDetail(data);
        } catch (error) {
            message.error('加载部门详情失败');
        } finally {
            setDetailLoading(false);
        }
    };

    useEffect(() => { loadPeriods(); }, [loadPeriods]);
    useEffect(() => { if (selectedPeriodId) loadStatistics(); }, [selectedPeriodId, loadStatistics]);

    return {
        // State
        loading,
        periods,
        selectedPeriodId,
        statistics,
        detailModalVisible,
        detailLoading,
        selectedDeptDetail,
        entryModalVisible,
        // Actions
        setSelectedPeriodId,
        loadStatistics,
        viewDepartmentDetail,
        setDetailModalVisible,
        setEntryModalVisible,
    };
};
